export default "__VITE_ASSET__h88RsGFE__"